import { createReducer, updateState } from "redux/handlers"
import { colsShowInit } from 'constants/conversationSearch'
import types from './types'

const initialState = {
  msgFilterEvent: 'all',
  smartChatCollapse: [],
  conversation: {
    searchUserCols: [...colsShowInit]
  }
}

const set = (state, action) => {
  const nextSettings = action.settings

  if (nextSettings?.conversation?.searchUserCols?.length === 0) {
    nextSettings.conversation.searchUserCols = [...colsShowInit]
  }

  return updateState(state, { ...nextSettings })
}

export default createReducer(initialState, {
  [types.SETTINGS_OPERATOR]: set,
})
